import JPaper from '@atoms/JPaper';
import { styled } from '@mui/material';

export const IconBoxStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.palette.primary.main,
  borderRadius: '50%',
  height: 40,
  width: 40,
}));

export const RedDotStyeld = styled('div')(({ theme }) => ({
  background: theme.palette.error.main,
  borderRadius: '50%',
  height: 12,
  width: 12,
}));

export const GrayDotStyeld = styled(RedDotStyeld)(({ theme }) => ({
  background: theme.palette.dark.dark_4,
}));

export const JPaperStyled = styled(JPaper)(({ theme }) => ({
  ':hover': {
    cursor: 'pointer',
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.06)',
  },
}));
